import {connect} from 'react-redux';
import {continueUrl} from 'src/shared/redirect/selectors';
import {currentView} from 'src/shared/currentView/selectors';
import {Page} from 'src/pages/reportIssue/components/Page';
import {scheduleCallback, status} from 'src/shared/pagePaths';
import {smsNumber} from 'src/pages/reportIssue/store/selectors/smsNumber';
import {enrollSms} from 'src/pages/reportIssue/store/actions/enrollSms';

export const mapStateToProps = state => ({
  continueUrl: continueUrl(state),
  currentView: currentView(state),
  scheduleCallbackUrl: scheduleCallback(),
  smsNumber: smsNumber(state),
  statusCenterUrl: status(),
});

export const mapDispatchToProps = dispatch => ({
  enrollSms: mobileNumber => dispatch(enrollSms(mobileNumber)),
});

export const App = connect(mapStateToProps, mapDispatchToProps)(Page);
